import React from 'react';
import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
    label: string;
    path: string;
    active: boolean
}

export interface BreadcrumbProps {
    crumbs: BreadcrumbItem[];
    separator?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ crumbs, separator = '/' }) => {
    const navigate = useNavigate();

    if (!crumbs || crumbs.length === 0) {
        return null;
    }

    const handleClick = (path: string) => {
        navigate(path);
    };

    return (
        <nav aria-label="breadcrumb">
            <ol className="flex">
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <li
                            key={index}
                            className={`breadcrumb-item`}
                            {...(!isLast && {
                                onClick: () => handleClick(crumb.path),
                                style: { cursor: 'pointer' },
                            })}
                        >
                            <span className={`px-2 lowercase ${crumb.active ? 'underline text-[#1e40af] font-medium' : 'text-[#4e4e4f]'}`}>{crumb.label}</span>
                            {!isLast && <span className="separator">{separator}</span>}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export { Breadcrumb };
